var jbhotels = {
    "type": "FeatureCollection",
    "features": [
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Hotel Cipriani, A Belmond Hotel",
        //         "address": "Giudecca 10",
        //         "city": "Venice",
        //         "country": "Italy",
        //         "category": "Hotels",
        //         "hotel_description": "A luxury hotel that welcomes pets, ensuring a comfortable stay with breathtaking views of Venice.",
        //         "caption": "Luxury with a view \u2013 where pets are treated like royalty.",
        //         "date": "2025-02-02",
        //         "day_number": 1,
        //         "source": "Belmond Official Website",
        //         "website": "https://www.belmond.com/hotels/europe/italy/venice/belmond-hotel-cipriani",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, pet cleaning fee applies"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             12.341311,
        //             45.426082
        //         ]
        //     }
        // },


        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "The Ritz-Carlton Bacara",
        //         "address": "8301 Hollister Ave",
        //         "city": "Santa Barbara",
        //         "country": "USA",
        //         "category": "Hotels",
        //         "hotel_description": "A luxurious beachfront resort with top-tier amenities and a warm welcome for pets.",
        //         "caption": "Beachfront luxury with a pet-friendly touch.",
        //         "date": "2025-02-07",
        //         "day_number": 7,
        //         "source": "Ritz-Carlton Official Website",
        //         "website": "https://www.ritzcarlton.com/en/hotels/california/bacara-santa-barbara",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, $150 per stay"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             -119.8826,
        //             34.4351
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Hotel Adlon Kempinski",
        //         "address": "Unter den Linden 77",
        //         "city": "Berlin",
        //         "country": "Germany",
        //         "category": "Hotels",
        //         "hotel_description": "A historic luxury hotel that offers pet-friendly rooms, ensuring a grand experience for pets and owners alike.",
        //         "caption": "Timeless elegance meets pet-friendly hospitality.",
        //         "date": "2025-02-08",
        //         "day_number": 8,
        //         "source": "Kempinski Official Website",
        //         "website": "https://www.kempinski.com/en/berlin/hotel-adlon/",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, EUR 50 per night"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             13.3785,
        //             52.5163
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "The Peninsula New York",
        //         "address": "700 5th Ave",
        //         "city": "New York City",
        //         "country": "USA",
        //         "category": "Hotels",
        //         "hotel_description": "A luxury Midtown Manhattan hotel offering pet-friendly accommodations with lavish amenities.",
        //         "caption": "Pampering pets with Manhattan's finest hospitality.",
        //         "date": "2025-02-10",
        //         "day_number": 10,
        //         "source": "The Peninsula Official Website",
        //         "website": "https://www.peninsula.com/en/new-york/5-star-luxury-hotel-midtown",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, $150 per stay"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             -73.9747,
        //             40.7616
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Hotel Bayerischer Hof",
        //         "address": "Promenadepl. 2-6",
        //         "city": "Munich",
        //         "country": "Germany",
        //         "category": "Hotels",
        //         "hotel_description": "One of Munich's most prestigious hotels, offering pet-friendly accommodations with luxury services.",
        //         "caption": "A Bavarian luxury retreat for you and your pet.",
        //         "date": "2025-02-11",
        //         "day_number": 11,
        //         "source": "Bayerischer Hof Official Website",
        //         "website": "https://www.bayerischerhof.de/en/home.html",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, EUR 40 per night"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             11.5736,
        //             48.1415
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Copacabana Palace, A Belmond Hotel",
        //         "address": "Avenida Atl\u00e2ntica 1702",
        //         "city": "Rio de Janeiro",
        //         "country": "Brazil",
        //         "category": "Hotels",
        //         "hotel_description": "A legendary beachfront hotel offering luxurious pet-friendly accommodations.",
        //         "caption": "Beach vibes and five-star luxury for you and your pet.",
        //         "date": "2025-02-12",
        //         "day_number": 12,
        //         "source": "Belmond Official Website",
        //         "website": "https://www.belmond.com/hotels/south-america/brazil/rio-de-janeiro/copacabana-palace/",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, BRL 400 per stay"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             -43.1785,
        //             -22.9671
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "The RuMa Hotel and Residences",
        //         "address": "7 Jalan Kia Peng",
        //         "city": "Kuala Lumpur",
        //         "country": "Malaysia",
        //         "category": "Hotels",
        //         "hotel_description": "A luxurious and modern hotel that welcomes pets with style and comfort.",
        //         "caption": "A city escape with pet-friendly luxury in Kuala Lumpur.",
        //         "date": "2025-02-04",
        //         "day_number": 3,
        //         "source": "RuMa Official Website",
        //         "website": "https://www.theruma.com/",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, MYR 150 per stay"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             101.7144,
        //             3.1516
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //       "star": "5 Star Hotel",
        //         "name": "Wanda Realm Harbin Hotel",
        //         "address": "No.158 Zhongxing Avenue",
        //         "city": "Harbin",
        //         "country": "China",
        //         "category": "Hotels",
        //         "hotel_description": "A premium hotel with modern amenities and a pet-friendly policy for guests traveling with their furry friends.",
        //         "caption": "Harbin's cozy retreat for winter travelers and their pets.",
        //         "date": "2025-02-05",
        //         "day_number": 4,
        //         "source": "Wanda Hotels Official Website",
        //         "website": "https://www.wandahotels.com/",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, RMB 200 per stay",
        //         "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/harbin1.png?v=1740540141",
        //         "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Screenshot_2025-03-03_at_9.10.49_PM.png?v=1741065594",
        //         "product_link": "https://jbthejetsetter.com/products/day-7-harbins-ice-festival",
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             126.6333,
        //             45.7566
        //         ]
        //     }
        // },
       // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Sofitel Harbin \u2013 French Elegance in the Ice City",
        //         "address": "68 Ganshui Road, Xiangfang District, Harbin, China",
        //         "city": "Harbin",
        //         "country": "China",
        //         "category": "event",
        //         "month": "Year-Round",
        //         "collection_name": "celebration",
        //         "highlight": "A luxury five-star hotel combining French sophistication with modern comfort in the heart of Harbin.",
        //         "hotel_description": "Experience world-class hospitality at Sofitel Harbin, where French art de vivre meets Chinese warmth. Enjoy gourmet dining, luxury spa treatments, and easy access to Harbin's top attractions.",
        //         "caption": "Where French elegance meets Harbin's winter wonderland\u2014luxury, style, and comfort await. \u2744\ufe0f\u2728",
        //         "morning": "Begin your day with an exquisite breakfast at the hotel's French patisserie, followed by a visit to Harbin's iconic Saint Sophia Cathedral.",
        //         "midday": "Relax with a signature spa treatment or indulge in fine Chinese and French cuisine at one of the hotel's award-winning restaurants.",
        //         "afternoon": "Explore the famous Harbin Ice and Snow Festival or take a leisurely stroll along the scenic Songhua River.",
        //         "evening": "Sip on handcrafted cocktails at the elegant lobby lounge before retiring to your luxurious suite with panoramic city views.",
        //         "website": "https://www.sofitel.com/gb/hotel-6249-sofitel-harbin/index.shtml",
        //         "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/harbin1.png?v=1740540141",
        //         "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Screenshot_2025-03-03_at_9.10.49_PM.png?v=1741065594",
        //         "product_link": "https://jbthejetsetter.com/products/day-7-harbins-ice-festival",
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             126.656,
        //             45.742
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Eslite Hotel",
        //         "address": "No. 98, Yanchang Road, Xinyi District",
        //         "city": "Taipei",
        //         "country": "Taiwan",
        //         "category": "Hotels",
        //         "hotel_description": "A boutique hotel in Taipei with an artistic ambiance and a pet-friendly policy.",
        //         "caption": "Where elegance meets pet-friendly luxury in Taipei.",
        //         "date": "2025-02-06",
        //         "day_number": 5,
        //         "source": "Eslite Hotel Official Website",
        //         "website": "https://www.eslitehotel.com/",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, TWD 500 per night"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             121.5645,
        //             25.0444
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Cross Hotel Sapporo",
        //         "address": "Chuo-ku, Kita 2-jo Nishi 2-chome",
        //         "city": "Sapporo",
        //         "country": "Japan",
        //         "category": "Hotels",
        //         "hotel_description": "A chic and comfortable hotel in Sapporo that offers pet-friendly accommodations.",
        //         "caption": "Sapporo's stylish escape for pets and owners alike.",
        //         "date": "2025-02-07",
        //         "day_number": 6,
        //         "source": "Cross Hotels Official Website",
        //         "website": "https://www.crosshotel.com/sapporo/",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "4 Star Hotel",
        //         "extra_fees": "Yes, JPY 3000 per night"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             141.3544,
        //             43.0621
        //         ]
        //     }
        // },
        // {
        //     "type": "Feature",
        //     "properties": {
        //         "name": "Hyatt Regency Addis Ababa",
        //         "address": "Meskel Square",
        //         "city": "Addis Ababa",
        //         "country": "Ethiopia",
        //         "category": "Hotels",
        //         "hotel_description": "A world-class luxury hotel in the heart of Addis Ababa that is pet-friendly.",
        //         "caption": "African luxury with a pet-friendly touch in Addis Ababa.",
        //         "date": "2025-02-08",
        //         "day_number": 7,
        //         "source": "Hyatt Official Website",
        //         "website": "https://www.hyatt.com/en-US/hotel/ethiopia/hyatt-regency-addis-ababa/addra",
        //         "month": "February",
        //         "collection_name": "Celebration",
        //         "classification": "5 Star Hotel",
        //         "extra_fees": "Yes, ETB 500 per night"
        //     },
        //     "geometry": {
        //         "type": "Point",
        //         "coordinates": [
        //             38.7528,
        //             9.0301
        //         ]
        //     }
        // },

    // {
    //   "type": "Feature",
    //   "properties": {
    //             "star": "4 star hotel",
    //             "week_num": 1,
    //             "season": "Winter 25'",
    //             "date": "2025-01-03",
    //             "category": "Event",
    //             "month": "January",
    //             "collection_name": "World Tour",
    //             "rating": "",
    //             "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capetown1.png?v=1740540073",
    //             "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Screenshot_2025-03-03_at_9.10.49_PM.png?v=1741065594",
    //             "product_link": "https://jbthejetsetter.com/products/week-1-cape-town-the-atlantic-jewel",
    //     "name": "Radisson RED Cape Town",
    //     "address": "No. 6 Silo Square, V&A Waterfront",
    //     "city": "Cape Town",
    //     "country": "South Africa",
    //     "experience_description": "A modern, artsy hotel with a vibrant atmosphere, welcoming pets and offering easy access to Table Mountain and the V&A Waterfront.",
    //     "caption": "Contemporary design meets pet-friendly vibes.",
    //     "source": "https://www.radissonhotels.com/en-us/hotels/radisson-red-cape-town-va-waterfront",
    //     "website": "https://www.radissonhotels.com/en-us/hotels/radisson-red-cape-town-va-waterfront"
    //   },
    //   "geometry": {
    //     "type": "Point",
    //     "coordinates": [18.4256, -33.9075]
    //   }
    // },
    // {
    //   "type": "Feature",
    //   "properties": {
    //             "star": "5 star hotel",
    //             "week_num": 1,
    //             "season": "Winter 25'",
    //             "date": "2025-01-03",
    //             "category": "Event",
    //             "month": "January",
    //             "collection_name": "World Tour",
    //             "rating": "",
    //             "img_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/capetown1.png?v=1740540073",
    //             "icon_url": "https://cdn.shopify.com/s/files/1/0644/0121/1590/files/Screenshot_2025-03-03_at_9.10.49_PM.png?v=1741065594",
    //             "product_link": "https://jbthejetsetter.com/products/week-1-cape-town-the-atlantic-jewel",
    //     "name": "Cape Grace Hotel",
    //     "address": "West Quay Rd, V&A Waterfront",
    //     "city": "Cape Town",
    //     "country": "South Africa",
    //     "experience_description": "A timeless luxury hotel offering pet-friendly accommodations with views of Table Mountain or the harbor.",
    //     "caption": "Classic elegance with a pet-friendly touch.",
    //     "source": "http://www.capegrace.com",
    //     "website": "http://www.capegrace.com",
        
    //   },
    //   "geometry": {
    //     "type": "Point",
    //     "coordinates": [18.4239, -33.9098]
    //   }
    // }
    ]
}